export const VideoChatStateKeys = {
  not_started: 'not_started',
  on_going: 'on_going',
  ringing: 'ringing',
  waiting: 'waiting',
  declined: 'declined',
  hung_up: 'hung_up',
  busy: 'busy',
}
